import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    cliente: null,
    saved: false,
    refresh: false
  },
  getters: {
    cliente: state => state.cliente,
    saved: state => state.saved,
    refresh: state => state.refresh
  },
  mutations: {
    SET_CLIENTE (state, payload) {
      state.cliente = payload
    },
    CLEAR_CLIENTE (state) {
      state.cliente = null
    },
    SET_CLIENTE_SAVED (state) {
      state.saved = true
    },
    CLEAR_CLIENTE_SAVED (state) {
      state.saved = false
    },
    SET_REFRESH (state) {
      state.refresh = true
    },
    CLEAR_REFRESH (state) {
      state.refresh = false
    }
  },
  actions: {
  }
}
